import {EzAppLayout, EzThemeProvider} from '@ezcater/recipe';
import {Tooltip} from '@ezcater/tapas';
import LazyMotion from './components/LazyMotion';
import Routes from './Routes';
import ErrorBoundary from './components/ErrorBoundary';
import theme from './theme';
import './i18n';

const App = () => (
  <Tooltip.Provider>
    <LazyMotion>
      <EzThemeProvider theme={theme}>
        <EzAppLayout>
          <ErrorBoundary>
            <Routes />
          </ErrorBoundary>
        </EzAppLayout>
      </EzThemeProvider>
    </LazyMotion>
  </Tooltip.Provider>
);

export default App;
